export default __webpack_public_path__ + "static/media/first-place.b0874bf3.svg";